if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // MDN (client 08-06): ‹ › arrows step between images inside the zoom.
        // stopPropagation on POINTERUP is load-bearing: ModalDialog (global.js:610) hides on any
        // bubbled mouse pointerup; 'click' is stopped too for completeness.
        this.prevArrow = this.querySelector('.oi-modal-arrow--prev');
        this.nextArrow = this.querySelector('.oi-modal-arrow--next');
        [[this.prevArrow, -1], [this.nextArrow, 1]].forEach(([btn, dir]) => {
          if (!btn) return;
          btn.addEventListener('pointerup', (e) => e.stopPropagation());
          btn.addEventListener('click', (e) => { e.stopPropagation(); this.stepMedia(dir); });
        });
        // Document-level so arrow keys work wherever focus sits while the modal is open.
        this.onArrowKey = (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.stepMedia(-1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.stepMedia(1); }
        };
      }

      connectedCallback() {
        document.addEventListener('keydown', this.onArrowKey);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onArrowKey);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      mediaElements() {
        return Array.from(this.querySelectorAll('[role="document"] [data-media-id]'));
      }

      currentMediaIndex() {
        const medias = this.mediaElements();
        // Mid-smooth-scroll geometry lags rapid clicks — trust the last stepped index briefly.
        if (this._steppedIndex != null && Date.now() - this._steppedAt < 700) return this._steppedIndex;
        // <750 only the .active media is displayed (one-at-a-time swap) — geometry is useless there.
        const visible = medias.filter((m) => m.getBoundingClientRect().height > 0);
        if (visible.length === 1) return medias.indexOf(visible[0]);
        // Desktop scroll-stack: the image whose center is nearest the viewport center is "current" —
        // robust whether the user arrived by arrow or by free scrolling.
        const container = this.querySelector('[role="document"]');
        const mid = container.getBoundingClientRect().top + container.clientHeight / 2;
        let cur = 0;
        let best = Infinity;
        medias.forEach((m, i) => {
          if (m.getBoundingClientRect().height === 0) return;
          const r = m.getBoundingClientRect();
          const d = Math.abs((r.top + r.bottom) / 2 - mid);
          if (d < best) { best = d; cur = i; }
        });
        return cur;
      }

      stepMedia(dir) {
        const medias = this.mediaElements();
        if (medias.length < 2) return;
        const next = Math.min(medias.length - 1, Math.max(0, this.currentMediaIndex() + dir));
        this._steppedIndex = next;
        this._steppedAt = Date.now();
        medias.forEach((m, i) => m.classList.toggle('active', i === next));
        medias[next].scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.updateArrows(next, medias.length);
      }

      updateArrows(index, total) {
        if (this.prevArrow) this.prevArrow.toggleAttribute('disabled', index <= 0);
        if (this.nextArrow) this.nextArrow.toggleAttribute('disabled', index >= total - 1);
      }

      showActiveMedia() {
        this._steppedIndex = null;
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        this.updateArrows(this.mediaElements().indexOf(activeMedia), this.mediaElements().length);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
